<div class="patient-info" fxLayout="row" fxLayoutAlign="space-around center" *ngFor="let info of infos; let j = index">
    <mat-card class="patient-card">
        <mat-card-header class="patient-card-header" [ngStyle]="{ 'background-color': getBackgroundColor(j) }" >
            <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
                <div class="patient-name">{{ info.name}}</div>
                <div>
                    <mat-icon class="battery-icon">{{ getBatteryIcon(info.battery) }}</mat-icon>
                </div>
                <div class="elapsed-time">{{ info.isFilled ? '経過時間: ' + info.elapsedTime : '' }}</div>
            </mat-card-title>
            <mat-icon [svgIcon]="info.isFilled ? 'filled-icon' : 'not-filled-icon'" class="survey-icon" (click)="survey(info)"></mat-icon>
        </mat-card-header>
        <mat-card-content class="icon-area">
            <div class="status-item" *ngFor="let status of statuses; let i = index">
                <div>
                    <mat-icon [svgIcon]="status.icon" class="status-icon"></mat-icon>
                    <span class="status-value">{{ info.data[i] == "0" ? "&nbsp;" : info.data[i] }}</span>
                </div>
                <h6 class="status-text">{{ status.text }}</h6>
            </div>
        </mat-card-content>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-icon svgIcon="{{ getDetailIcon(j) }}" class="detail-icon" (click)="history(info)"></mat-icon>
            <div class="measurement-time" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon svgIcon="time-icon" class="time-icon"></mat-icon>
                <span>測定日時 : {{ info.measurementTime }}</span>
            </div>
        </div>
    </mat-card>
</div>